function appBaseUrl(): string {
  return `${window.location.protocol}//${window.location.host}/#`;
}

export function eventPageUrl(eventId: number): string {
  return `${appBaseUrl()}/event/details/${eventId}`;
}

export function categoryResultsUrl(eventId: number, categoryId: number): string {
  return `${appBaseUrl()}/results/${eventId}/${categoryId}`;
}
